<template>
    <b-modal 
          id="add-anexo-modal"
          size="md"
          button-size="sm"
          centered
          header-bg-variant="secondary"
          header-text-variant="light"
          header-class=""
          footer-class=""
          modal-class="p-2"
          no-close-on-backdrop
          no-close-on-esc
        >
          <template v-slot:modal-header="">
            <h5>Escolher arquivo</h5>
          </template>                    
          <b-row>
            <b-col>
              <b-form-group
                id="arquivo-input-group"
                label="Arquivos*"
                label-for="input-arquivo"
                label-cols="auto"
              >
                  <b-form-file
                    v-model="arquivos"
                    placeholder="Escolha os arquivos..."
                    drop-placeholder="Solte o arquivo aqui..."
                    class=""
                    browse-text="Escolher"
                    accept=".pdf, .zip"
                    multiple
                  ></b-form-file>
                  <div class="mt-2" v-if="arquivos.length > 0" id="arquivosSelecionadosInfo">
                    <span>Arquivos selecionados:</span>
                    <ul id="lista-anexos">
                      <li v-for="arquivo in arquivos" :key="arquivo.name">
                        {{arquivo.name}}
                      </li>
                    </ul>
                  </div>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-slot:modal-footer="">
            <b-button :disabled="arquivos.length < 1" size="sm" @click="addAnexos()">
              Confirmar
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="fecharModalAdicionarAnexo()">
              Cancelar
            </b-button>
          </template>
        </b-modal>
</template>

<script>
import messagesService from "@/services/messagesService"

export default {
    name: "modal-adicionar-anexo",
    data() {
        return {
          arquivos: [],
        }
    },

    methods: {
        fecharModalAdicionarAnexo() {
          this.$bvModal.hide('add-anexo-modal')
          this.$emit("fecharModalAdicionarAnexo")
        },

        async addAnexos() {
          const response = await messagesService.adicionarAnexos(this.arquivos, this.$parent.idAviso, 'aviso')
          if(response && response.status === 200) {
            this.$toast.success("Anexos salvos com sucesso")
          }
          else if(response && response.status === 400) {
            this.$toast.error(response.data.msg)
          }
          else {
            this.$toast.error("Erro ao salvar os anexos")
          }
          this.fecharModalAdicionarAnexo()
        },
    },

    async mounted() {
        this.$bvModal.show("add-anexo-modal");
    }
}
</script>

<style>
#input-group-filtroUg .multiselect__option--selected {
    color: #fff !important;
    background: #a2a9af  !important;
    font-weight: 400;
}
</style>